import { createTheme } from "@mui/material/styles";

import { spacingScale } from "@app/theme/weaveTokens.ts";

/**
 * The app's `theme.spacing`, built from Weave spacing tokens.
 *
 * The DHIG scale is an array, so `spacing(1)` is 4px and `spacing(0)` is 0.
 * Weave legacy's own array is `[4, 8, 12, 16, 24, 32, 48]` (index 0 is 4px and
 * index 7 and up overflow) and Weave brand uses an 8px multiplier, so each index
 * means something different in all three. About 180 `sx` and system-prop sites
 * pass numbers that assume the DHIG scale, so it stays until those sites use
 * tokens (DEVX-11164). Weave components never call `theme.spacing`, so this
 * only affects our code and the DHIG components that remain.
 */
export const appSpacing = createTheme({ spacing: spacingScale }).spacing;
